import axiosInstance from "../utils/axios";

export const GetProfileDetail = async (id) => {
    return await axiosInstance().get(`admin/editprofile?id=${id}`);
};

export const GetEditProfile = async (values) => {
    return await axiosInstance().post("admin/editprofile", values)
}